import React from 'react'
import { useForm } from 'react-hook-form'
import SelectInput from '../../../../../../components/Input/SelectInput'
import { api } from '../../../../../../services/api'
import { Row } from '../../../../../../components/commons'
import { theme } from '../../../../../../styles/theme'
import { ThreeDots } from 'react-loader-spinner'
import { FaMagnifyingGlass, FaPlus } from 'react-icons/fa6'
import { ButtonRound } from '../../../../../../components/Header/styles'
import { Group } from '../../../../../../services/groups.service'

export interface SearchGroupProps {
  onSelectGroup: (selectedUser: any, reset: () => void, item?: any) => void
  loadingSubmit: boolean
  menuPortalTarget?: any
  menuPosition?: any
}

const SearchGroup: React.FunctionComponent<SearchGroupProps> = ({
  loadingSubmit,
  onSelectGroup,
  menuPosition,
  menuPortalTarget,
}) => {
  const [isLoading, setIsLoading] = React.useState(true)
  const [groups, setGroups] = React.useState<Group[]>([])

  const {
    control,
    handleSubmit,
    getValues,
    reset,
    formState: { errors },
  } = useForm<{
    search: ''
  }>()

  const handleSubmitFunc = async () => {
    const formValue = getValues()

    if (formValue.search !== '' && formValue.search)
      onSelectGroup(
        formValue.search,
        reset,
        groups.find((group) => group._id === formValue.search),
      )
  }

  const handleGetGroups = async (search?: string) => {
    try {
      setIsLoading(true)
      const { data: response } = await api.get(`/groups`, {
        params: {
          search: search,
        },
      })

      setGroups(response.data || [])
    } catch (error) {
      console.error('Erro ao buscar grupos:', error)
    } finally {
      setIsLoading(false)
    }
  }

  React.useEffect(() => {
    handleGetGroups('')
  }, [])

  return (
    <Row gap={15}>
      <SelectInput
        menuPosition={menuPosition || 'absolute'}
        menuPortalTarget={menuPortalTarget || document.body}
        error={errors?.search}
        Icon={<FaMagnifyingGlass size={25} />}
        isLoading={isLoading}
        onSelect={() => handleSubmitFunc()}
        onChangeText={(text) => {
          if (text !== '') {
            handleGetGroups(text)
          }
        }}
        options={(() => {
          const sortedGroups = [...groups].sort((a, b) => a.name.localeCompare(b.name))
          return sortedGroups.map((user: any) => ({
            value: user._id,
            label: `${user.name}`,
          }))
        })()}
        small
        isClearable
        isSearchable={true}
        placeholder="Selecione um grupo"
        zIndex={10000}
        control={control}
        name='search'
      />
      {loadingSubmit && (
        <ThreeDots
          wrapperStyle={{ justifyContent: 'center' }}
          color={theme.colors.primary}
          height={25}
          width={25}
        />
      )}
      {/* ) : (
        <ButtonRound
          style={{
            width: '25px',
            height: '25px',
            minWidth: '25px',
            minHeight: '25px',
          }}
          onClick={handleSubmit(handleSubmitFunc)}
        >
          <FaPlus color='white' />
        </ButtonRound>
      )} */}
    </Row>
  )
}

export default SearchGroup
